import { useEffect, useRef, useCallback } from 'react';
import { BlogPost } from './BlogPost';
import './PostsFeed.css';

export function PostsFeed({ posts, loading, error, hasMore, loadMore, loadingMore }) {
  const observerRef = useRef(null);
  const loadMoreRef = useRef(null);

  // Infinite scroll with Intersection Observer
  const handleObserver = useCallback((entries) => {
    const [entry] = entries;
    if (entry.isIntersecting && hasMore && !loadingMore) {
      loadMore();
    }
  }, [hasMore, loadMore, loadingMore]);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '100px',
      threshold: 0,
    };

    observerRef.current = new IntersectionObserver(handleObserver, option);

    if (loadMoreRef.current) {
      observerRef.current.observe(loadMoreRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [handleObserver]);

  if (loading) {
    return (
      <div className="posts-feed__loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="posts-feed__error text-sans">
        <p>Error loading posts: {error}</p>
      </div>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <div className="posts-feed__empty">
        <p className="text-muted">No posts yet.</p>
      </div>
    );
  }

  return (
    <div className="posts-feed">
      {posts.map((post) => (
        <BlogPost key={post.id} post={post} isPreview={true} />
      ))}

      {/* Infinite scroll trigger */}
      <div ref={loadMoreRef} className="posts-feed__sentinel">
        {loadingMore && (
          <div className="posts-feed__loading-more">
            <div className="spinner"></div>
          </div>
        )}
      </div>

      {!hasMore && posts.length > 0 && (
        <p className="posts-feed__end text-sans text-small text-muted">
          You've reached the end
        </p>
      )}
    </div>
  );
}
